import {
  Button,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  VisuallyHidden,
} from '@chakra-ui/react';
import * as React from 'react';
import { FaChevronDown } from 'react-icons/fa';
import { useLanguageSelector } from './hooks/useLanguageSelector';

export const LanguageSelector: React.FC = (): JSX.Element => {
  const { changeLanguage, language, languages } = useLanguageSelector();
  return (
    <Menu>
      <MenuButton
        _hover={{ boxShadow: 'none' }}
        as={Button}
        p={2}
        rightIcon={<Icon as={FaChevronDown} ml="-1rem" mx={1} />}
      >
        <language.icon countryCode={language.countryCode} h="22px" w="22px" />
      </MenuButton>
      <MenuList bg="brand.black" color="white" minW="max-content">
        {languages
          .filter((l) => l.id !== language.id)
          .map((lng) => (
            <MenuItem
              _active={{ bg: 'transparent' }}
              _focus={{ bg: 'transparent' }}
              key={`language-${lng.id}`}
              m={2}
              p={2}
              onClick={(): void => {
                changeLanguage(lng.id);
              }}
            >
              <VisuallyHidden>{lng.label}</VisuallyHidden>
              <lng.icon countryCode={lng.countryCode} h="26px" w="26px" />
            </MenuItem>
          ))}
      </MenuList>
    </Menu>
  );
};
